import type { OpenCloudAPISchema, OpenCloudAPIObjectReference } from '../../utils/oasTypes';

export default function isObjectReference(
  schema: OpenCloudAPISchema,
): schema is OpenCloudAPIObjectReference {
  return schema !== null && 'refType' in schema && 'name' in schema;
}
